module.exports = __webpack_public_path__ + "static/media/tlk_wave.1f9478cf.png";